<template>
  <div v-if="destination.times.length" role="list">
    <div class="horaire-time schedule-listing-row" role="listitem" v-for="(tdata, index) in destination.times" :key="index">
      <span class="headsign griditem-1">{{ tdata.tripHeadsign }}</span>
      <span class="time griditem-2">
        <ApthScheduleTime
          :timeData="tdata"
          :indicators="indicators"
          :showOccupancy="showOccupancy"
          :showDeparture="showDeparture"
          :showTerminus="showTerminus"
          :alwaysShowHours="alwaysShowHours"
        />
      </span>
    </div>
  </div>
  <div v-else>
    <em>{{ $t("notFound") }}</em>
  </div>
</template>

<script>
import ApthScheduleTime from "./ApthScheduleTime";
export default {
  name: "ApthScheduleStopDestinationVertical",
  data() {
    return {};
  },
  components: {
    ApthScheduleTime
  },
  computed: {
    lineModeStyle() {
      const lineModeStyles = {
        BUS: "iconMode modeBus",
        TRAM: "iconMode modeTram",
        RAIL: "iconMode modeRail",
        SUBWAY: "iconMode modeSubway",
        FERRY: "iconMode modeFerry",
        CABLECAR: "iconMode modeCablecar",
        GONDOLA: "iconMode modeGondola",
        FUNICULAR: "iconMode modeFunicular"
      };
      return lineModeStyles[this.destination.line.mode];
    },
    lineColorStyle() {
      if (this.destination && this.destination.line && this.destination.line.colors){
        var txtColor = this.destination.line.colors.color;
        var bgColor = this.destination.line.colors.bgcolor;
        if (txtColor && bgColor) {
          return "background-color:" + bgColor + ";color:" + txtColor + ";";
        }
      }
      return "";
    },
  },
  props: {
    /* destination: {
     *   busTime: {
     *     timeDatas: [timeData] // timeData: { reliability, isDeparture, isTerminus, minutes, time }
     *   },
     *   firstTime: { nameDest: String }
     *   line: {
     *     mode: String, ('BUS', 'TRAM', 'RAIL',...)
     *     colors: {
     *       color: String,
     *       bgcolor: String,
     *     }
     *   }
     * }
     */
    destination: {
      type: Object,
      required: true
    },
    showOccupancy: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDeparture: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTerminus: {
      type: Boolean,
      required: false,
      default: true,
    },
    alwaysShowHours: {
      type: Boolean,
      required: false,
      default: false,
    },
    indicators: {
      type: Object,
      required: false,
      default: () => {
        return {
          'any': true,
        };
      },
    },
  },
  methods: {
    formatDate(date){
      return date.toLocaleString().split(' ')[0].replace(",", ""); // XXX : toLocalString() ajoute une virgule après l'année pour l'anglais et l'italien...
    }

  }
};
</script>

<style lang="scss">
// variable
@import "../styles/utilities/_variables.scss";

.schedule-listing-row {

  .griditem-1 {
    justify-self: start;
  }
  .griditem-2 {
    justify-self: end;
  }
}

.pthvSchedule-row {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border: 1px solid #eee;
  margin-bottom: -1px;
  font-family: $apth_fontFamily;
  &:hover,
  &:focus {
    background-color: rgba($apth_color-black, 0.05);
  }
}
.pthvSchedule-line {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  span {
    display: inline-block;
  }
}
.pthvSchedule-numLine {
  padding: 0.25rem;
  min-width: 1.5rem;
  margin-right: 0.25rem;
  text-align: center;
  border-radius: 3px;
}
.pthvSchedule-nextDeparture {
  margin-left: auto;
}
.pthvSchedule-times {
  display: flex;
}

.horaire-time {
    background-color: #F2F2F2;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    margin: 1rem 0;
}
</style>
